module.exports = __webpack_public_path__ + "img/img1.3b1526d.png";